<template>
    <div class="page-content">
        <SketchBreadcrumb ref="scrollTo" pageName="Dosarul tău complet"></SketchBreadcrumb>
        <div class="padding-box">
            <b-overlay :show="documentDownload" :opacity="opacity" :blur="blur" :variant="documentVariant" no-center>
                <template #overlay>
                    <div class="loading-overlay">
                        <b-spinner></b-spinner>
                        <p style="text-align: center; margin-bottom: 5px; margin-top: 15px; font-size: 15px; color: #777e90;" v-html="loadingText"></p>
                    </div>
                </template>
                <div class="white-box">
                    <div class="table-header flex space-between align-center">
                        <p>Mai jos regăsești lista de documente necesare pentru a aplica la acest apel de finanțare</p>
                        <div class="legend">
                            <a class="download-button" @click="downloadAll()">Descarcă toate documentele</a>
                        </div>
                    </div>
                </div>
                <div class="customTable">
                    <b-table id="TabelFisiere" striped borderless hover responsive :fields="fields" head-variant="light"></b-table>
                    <div>
                        <div class="tableHead">DOCUMENTELE COMPANIEI</div>
                        <b-table id="TabelFisiereFinal" sticky-header hover responsive :items="docs" :fields="fields" head-variant="light" thead-class="hidden_header">
                            <template v-slot:cell(name)="data">
                                <div class="relative">
                                    <span class="document_name">{{ data.value }}</span>
                                    <div class="checkbox-container absolute-left text-align-center">
                                        <b-icon-x-circle-fill v-if="(data.item.files.file == null) && !data.item.generated" variant="danger" scale="1.5"></b-icon-x-circle-fill>
                                        <b-icon-check-circle-fill v-if="data.item.completed || data.item.files.file" variant="success" scale="1.5"></b-icon-check-circle-fill>
                                        <img v-if="!data.item.completed && data.item.files.file==null &&data.item.generated" src="@/assets/images/M3/M3Sketch/warn-vector.svg" alt="warn-sign" class="warn_image">
                                    </div>
                                </div>
                            </template>
                            <template v-slot:cell(ext)="data">
                                <span ><strong>{{ data.value }}</strong></span>
                            </template>
                            <template v-slot:cell(download)="data">
                                <div>
                                    <a v-if="data.item.files.file" :href="prepareDownloadUrl(data.item)" download>
                                        <img v-if="data.item.value === 'financial_forecasts'" src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="uploaded_icon" >
                                        <img v-else-if="data.item.icon && data.item.icon === 'xlsx'" src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="uploaded_icon" >
                                        <img v-else-if="data.item.icon && data.item.icon === 'docx'" src="@/assets/images/M3/M3Sketch/word_icon.png" class="download_icon" alt="uploaded_icon" >
                                        <img v-else src="@/assets/images/M3/M3Sketch/pdf_icon.png" class="download_icon" alt="uploaded_icon" >
                                    </a>
                                    <img v-if="data.item.files.pdf || data.item.files.pdf === null" src="@/assets/images/M3/M3Sketch/pdf_icon.png" class="download_icon" alt="pdf_icon" @click="downloadFile(data.item.files.pdf)">
                                    <img v-if="data.item.files.xlsx || data.item.files.xlsx === null" src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="exel_icon" @click="downloadFile(data.item.files.xlsx)">
                                    <img v-if="data.item.files.doc && data.item.special_generated" src="@/assets/images/M3/M3Sketch/static_word_icon.png" class="download_icon" alt="static_word_icon" @click="downloadFile(data.item.files.doc)" >
                                    <img v-else-if="data.item.files.doc || data.item.files.doc === null" src="@/assets/images/M3/M3Sketch/word_icon.png" class="download_icon" alt="word_icon" @click="downloadFile(data.item.files.doc)" >
                                    <a v-if="data.item.generated" :href="data.item.template" target="_blank">
                                        <img src="@/assets/images/M3/M3Sketch/model-icon.png" class="download_icon" alt="">
                                    </a>
                                </div>
                            </template>
                            <template v-slot:cell(observatii)="data">
                                <span v-if="data.item.value === 'financial_forecasts' && !data.item.files.file" :class="{green_text: data.item.completed || data.item.files.file, red_text: !data.item.files.file && !data.item.generated}"><strong>Te rugăm să încarci documentul în pagina <router-link to="/aplicatii/m3-sketch/indicatori">indicatori</router-link></strong></span>
                                <span v-else-if="!data.item.files.file" :class="{green_text: data.item.completed || data.item.files.file, red_text: !data.item.files.file && !data.item.generated}"><strong>Te rugăm să încarci documentul în pagina <router-link to="/aplicatii/m3-sketch/checklist">checklist</router-link></strong></span>
                                <span
                                    v-else
                                    :class="{
                                        green_text: data.item.completed || data.item.files.file,
                                        red_text: !data.item.files.file && !data.item.generated,
                                    }"
                                    v-html="checkDocumentUpload(data.item)"
                                ></span>
                            </template>
                        </b-table>
                    </div>
                </div>
                <div class="gray-background">
                    <h3>Documente generate prin <strong>POC</strong>Sketch</h3>
                    <div class="yellow-warn-wide">
                        <img src="@/assets/images/M3/M3Sketch/warn-vector.svg" style="max-width: 50px;">
                        <p>
                            Descarcă mai jos, documentele generate automat. Te rugăm <strong>să verifici cu atenție toate datele din anexele generate.</strong>
                            <br>
                            Nu ne asumăm responsabilitatea pentru eventualele erori care ar putea duce la respingerea cererii de finanțare.
                            <br>
                            <strong>Aplicantul, în calitate de beneficiar, își asumă în totalitate responsabilitatea pentru documentele depuse.</strong>
                        </p>
                        <img src="@/assets/images/M3/M3Sketch/warn-vector.svg" style="max-width: 50px;">
                    </div>
                    <div class="blue-button-download"><a href="/documents/Anexe-411(Redesign-SMIS).zip" download>Descarcă modelele Anexelor (redesign Smis)</a></div>
                    <h2>Funcția de generare automată a documentelor este disponibilă utilizatorilor licențiați.</h2>
                    <p>După ce te-ai asigurat că anexele conțin informații corecte și complete, salvează fiecare anexă în format pdf, și semnează digital anexele în scopul încărcării în IMM Recover.</p>
                </div>
                <div class="customTable">
                    <b-table id="TabelFisiereFinal" sticky-header hover responsive :items="docsGenerated" :fields="fields" head-variant="light" thead-class="hidden_header">
                        <template v-slot:cell(name)="data">
                            <div class="relative">
                                <span class="document_name">{{ data.value }}</span>
                                <div class="checkbox-container absolute-left text-align-center">
                                    <img v-if="data.item.value === 'imm_doc' || data.item.value === 'aid_doc'" src="@/assets/images/M3/M3Sketch/info-icon-blue.png" alt="warn-sign" class="warn_image">
                                    <img v-else-if="data.item.value === 'zip_offers' && data.item.empty" src="@/assets/images/M3/M3Sketch/warn-vector.svg" alt="warn-sign" class="warn_image">
                                    <b-icon-x-circle-fill v-else-if="(data.item.files.file == null) && !data.item.generated" variant="danger" scale="1.5"></b-icon-x-circle-fill>
                                    <b-icon-check-circle-fill v-else-if="data.item.completed || data.item.files.file" variant="success" scale="1.5"></b-icon-check-circle-fill>
                                    <img v-else-if="!data.item.completed && data.item.files.file==null &&data.item.generated" src="@/assets/images/M3/M3Sketch/warn-vector.svg" alt="warn-sign" class="warn_image">
                                </div>
                            </div>
                        </template>
                        <template v-slot:cell(ext)="data">
                            <span ><strong>{{ data.value }}</strong></span>
                        </template>
                        <template v-slot:cell(download)="data">
                            <div>
                                <div class="relative-image">
                                    <a v-if="data.item.files.file" :href="prepareDownloadUrl(data.item)" download>
                                        <img v-if="data.item.icon && data.item.icon === 'xlsx'" src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="uploaded_icon" >
                                        <img v-else-if="data.item.icon && data.item.icon === 'docx'" src="@/assets/images/M3/M3Sketch/word_icon.png" class="download_icon" alt="uploaded_icon" >
                                        <img v-else src="@/assets/images/M3/M3Sketch/pdf_icon.png" class="download_icon" alt="uploaded_icon" >
                                    </a>
                                    <a v-else-if="data.item.value === 'imm_doc'" :href="data.item.files.doc" download>
                                        <img v-if="data.item.value === 'imm_doc'" src="@/assets/images/M3/M3Sketch/word_icon.png" class="download_icon" alt="uploaded_icon" >
                                    </a>
                                    <img v-else-if="data.item.files.pdf || data.item.files.pdf === null" src="@/assets/images/M3/M3Sketch/pdf_icon.png" class="download_icon" alt="pdf_icon" @click="downloadFile(data.item.files.pdf)">
                                    <img v-else-if="data.item.files.xlsx || data.item.files.xlsx === null" src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="exel_icon" @click="downloadFile(data.item.files.xlsx)">
                                    <img v-else-if="data.item.files.doc && data.item.special_generated" src="@/assets/images/M3/M3Sketch/static_word_icon.png" class="download_icon" alt="static_word_icon" @click="downloadFile(data.item.files.doc)" >
                                    <img v-else-if="data.item.files.doc || data.item.files.doc === null" src="@/assets/images/M3/M3Sketch/word_icon.png" class="download_icon" alt="word_icon" @click="downloadFile(data.item.files.doc)" >
                                    <img v-else-if="data.item.files.zip || data.item.files.zip === null" src="@/assets/images/M3/M3Sketch/zip-pdf-icon.png" class="download_icon" alt="word_icon" @click="downloadFile(data.item.files.zip, data.item.value, data.item.empty)" >
                                    <img v-if="data.item.value === 'imm_doc' || data.item.value === 'aid_doc'" src="@/assets/images/M3/M3Sketch/info-icon-blue.png" alt="warn-sign" class="warn-absolute">
                                    <img v-else-if="!data.item.completed && data.item.files.file==null &&data.item.generated" src="@/assets/images/M3/M3Sketch/warn-vector.svg" alt="warn-sign" class="warn-absolute">
                                    <img v-else-if="data.item.value === 'zip_offers' && data.item.empty" src="@/assets/images/M3/M3Sketch/warn-vector.svg" alt="warn-sign" class="warn-absolute">
                                </div>
                                <!--                                    <a v-if="data.item.generated" :href="data.item.template" target="_blank">
                                        <img src="@/assets/images/M3/M3Sketch/model-icon.png" class="download_icon" alt="">
                                    </a>-->
                            </div>
                        </template>
                        <template v-slot:cell(observatii)="data">
                            <span
                                :class="{
                                    green_text: data.item.completed || data.item.files.file,
                                    red_text: !data.item.files.file && !data.item.generated,
                                }"
                                v-html="checkDocumentUpload(data.item)"
                            ></span>
                        </template>
                    </b-table>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
    import {
        BFormCheckbox,
        BTable,
        BIconUpload,
        BIconDownload,
        BIconX,
        BButton,
        BIconXCircleFill,
        BIconCheckCircleFill,
        BOverlay,
        BSpinner
    } from 'bootstrap-vue'
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import axios from '@/helpers/axios';
    import api from '@/helpers/api';
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'

    export default {
        components: {
            SketchBreadcrumb,
            LoadingSpinner,
            BFormCheckbox,
            BIconUpload,
            BIconDownload,
            BTable,
            BIconX,
            BButton,
            BIconXCircleFill,
            BIconCheckCircleFill,
            BOverlay,
            BSpinner
        },
        props: {
        },
        data() {
            return {
                /* LOADING */
                documentDownload: false,
                opacity: 0.95,
                blur: '20px',
                documentVariant: 'light',
                documentLight: false,
                loadingText: '',

                selected: 1,
                uploadedDocument:null,
                fields: [
                    {
                        key: 'name',
                        label: 'Document',
                    },
                    {
                        key: 'ext',
                        label: 'Model în anexă',
                    },
                    {
                        key: 'download',
                        label: 'Descarcă documentele',
                        class: 'icons',
                    },
                    {
                        key: 'observatii',
                        label: 'Observații',
                    }
                ],
                docs: [],
                docsGenerated: [],
                loading: false,
                downloadAllFilesUrl: '',
                company: null,
                documentsFolderName: 'dosar',

            }
        },
        mounted() {
            this.getDocuments();
            /*this.underConstruction();*/
            this.company = JSON.parse(localStorage.getItem('currentM3Company'));
            let name = this.company.name
            if(!this.company.paid) {
                this.documentsFolderName = 'dosar_poc_demo_'+name.replaceAll( /[^a-z0-9]+/ig, "_")+'.zip'
                this.loadingText = 'Ești în perioada de trial, iar dosarul tău complet va conține doar documentele gratuite.'
            } else {
                this.documentsFolderName = 'dosar_poc_'+name.replaceAll( /[^a-z0-9]+/ig, "_")+'.zip'
                this.loadingText = 'Dosarul tău complet se va descărca în scurt timp. <br>În medie, generarea documentelor durează 2-3 minute.'
            }
        },
        methods: {
            underConstruction() {
                this.$swal({
                    heightAuto: false,
                    title: 'Încă lucrăm la această funcționalitate. <br><br>Aceasta va fi 100% funcțională în maxim 10 zile lucrătoare de la lansarea ghidului final.<br>',
                    icon: 'info',
                    confirmButtonText: 'Închide'

                })
            },
            getDocuments(){
                let idCompanie =  JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).id : 0
                axios.get(api.API_ENDPOINTS.m3company + idCompanie + '/uploads')
                    .then( response => {
                        this.docs = response.data['DOCUMENTELE COMPANIEI'];
                        this.docsGenerated = response.data['DOCUMENTE CE VOR FI GENERATE AUTOMAT PRIN POC SKETCH'];
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
                    .catch( xhr => {
                        console.log(xhr);
                    })
            },
            checkDocumentUpload(doc){
                if(doc.empty && doc.value === 'zip_offers') {
                    return ' <strong style="color: var(--dangerColor) !important;">Atenție! Nu există achiziții în proiect.</strong>'
                }
                if(doc.completed && doc.generated && doc.value === 'zip_offers') {
                    return 'Descarcă ofertele de preț (arhivă)'
                }
                if(!doc.completed && doc.generated && doc.value === 'zip_offers') {
                    return ' <strong>Atenție! Cel puțin o achiziție nu are ambele oferte încărcate</strong>'
                }
                if(!doc.files.file && !doc.generated && doc.value !== 'financial_forecasts'){
                    return ' <strong>Documentul nu a fost încărcat.</strong>'
                }
                if(doc.value === 'imm_doc') {
                    return ' <strong style="color: #177dc1;">Atenție! Nu generăm acest document!</strong>'
                }
                if(doc.value === 'aid_doc') {
                    return ' <strong style="color: #177dc1;">Atenție! Necesită completări suplimentare</strong>'
                }
                if(!doc.files.file && !doc.generated && doc.value === 'financial_forecasts'){
                    return ' <strong>Te rugăm să încarci documentul în pagina <router-link to="/aplicatii/m3-sketch/indicatori">indicatori</router-link></strong>'
                }
                if(doc.completed && doc.generated){
                    return 'Document generat cu succces <strong>POC</strong>Sketch®';
                }
                if(!doc.completed && doc.generated) {
                    return '<span class="yellow-text"><strong>Document cu informații lipsă (descarcă sau editează)</strong></span>'
                }
                if(doc.special_generated && doc.value !== 'financial_indicators_doc') {
                    return 'Descarcă șablonul <strong>POC</strong>Sketch®'
                }
                if(doc.special_generated && doc.value === 'financial_indicators_doc') {
                    return 'Descarcă Excel indicatori financiari'
                }
                return 'Document încărcat cu succes'
            },
            rowClass(item, type){
                if (item.generated && item.is_free) return 'table-success'
                if (!item || type !== 'row') return
                if(item.files.file===null) return 'table-danger'
                if (!item.completed && !item.files.file) return 'table-warning'
            },
            downloadFile(link, value, isEmpty){
                if(link && this.company && this.company.paid){
                    if(value === 'zip_offers') {
                        if (isEmpty) {
                            this.$swal({
                                title: 'Te rugăm să adaugi cel puțin o achiziție sau să editezi una din cele prebugetate pentru a putea genera ofertele.',
                                icon: 'info',
                                confirmButtonText: 'Achiziții / cheltuieli',
                                showDenyButton: true,
                                denyButtonText: 'Anulează'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.$router.push({name: 'AchizitiiCheltuieli'});
                                }
                            })
                        } else {
                            this.$toast.success('Document în curs de generare.');
                            location.href = link
                        }
                    } else {
                        this.$toast.success('Document în curs de generare.');
                        location.href = link
                    }
                } else {
                    this.$swal({
                        title: 'Document disponibil companiilor cu licență activă.<br>Poți cumpăra o licență din pagina de mai jos.',
                        icon: 'info',
                        confirmButtonText: 'Cumpără licență',
                        showDenyButton: true,
                        denyButtonText: 'Anulează'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$router.push({name: 'M3SketchCumparaLicenta'});
                        }
                    })
                }
            },

            prepareDownloadUrl(doc){
                if(doc.files && doc.files.file) return doc.files.file
                return '#'
            },
            downloadAll(){
                let idCompanie =  JSON.parse(localStorage.getItem('currentM3Company')).id
                this.documentDownload = true
                /*
                this.$toast.success('Documentele se vor descărca in cateva secunde.');
                location.href = api.API_ROOT + api.API_ENDPOINTS.m3company + idCompanie + '/documents/all'
                this.documentDownload = false*/
                axios({url: api.API_ROOT + api.API_ENDPOINTS.m3company + idCompanie + '/documents/all', method: 'GET', responseType: 'blob'})
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.documentsFolderName);
                        document.body.appendChild(link);
                        link.click();
                        this.documentDownload = false
                        this.$mf.push('downloadAllDocuments', Date.now());
                    })
                    .catch(() => {
                        this.documentDownload = false
                    })
            },
        }
    }
</script>

<style scoped>
.gray-background{
    background: #f0f0f0;
    padding: 15px 0;
}
.gray-background h3{
    font-size: 16px;
    margin-bottom: 15px;
    color: #282828;
    text-align: center;
}
.gray-background h2{
    font-size: 19px;
    margin-bottom: 0;
    color: #282828;
    text-align: center;
}
.gray-background p{
    color: #282828;
    font-size: 13px;
    margin-bottom: 20px;
    text-align: center;
    font-weight: 500;
}
.yellow-warn-wide{
    background: #ffecb3;
    padding: 12px 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.yellow-warn-wide p{
    color: #282828;
    font-size: 13px;
    margin-bottom: 0;
    text-align: center;
}
.blue-button-download{
    background: #177dc1;
    color: #ffffff;
    text-align: center;
    font-size: 12px;
    padding: 10px 5px;
    max-width: 300px;
    margin: 25px auto;
    cursor: pointer;
    transition: 0.4s;
    border-radius: 3px;
}
.blue-button-download:hover{
    background: #136fad;
}
.blue-button-download a{
    text-decoration: none;
    color: inherit;
}
.relative-image{
    position: relative;
    width: fit-content;
    margin: 0 auto;
}
.warn-absolute{
    position: absolute;
    left: 17px;
    top: 0;
    max-width: 14px;
}
.loading-overlay{
    margin-top: 10%;
    width: 100%;
    text-align: center;
}
.tableHead{
	background: #fff;
	padding: 5px 25px;
	color: #777e90;
	font-size: 12px;
	font-weight: bold;
}
.padding-box{
    padding: 20px 20px 0 20px;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.white-spinner >>> img{
    filter: brightness(0) invert(1);
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.table-header{
    font-size: 14px;
    color: #5b6276;
    font-weight: 500;
}
.checkbox-container {
    display: flex;
    pointer-events: none;
    align-items: center;
}
.checkbox-container:not(:last-child){
    margin-bottom: 10px;
}
.download_icon{
    cursor: pointer;
}
.nume-checkbox {
    margin-left: 10px;
    color: #848484;
    cursor: pointer;
    font-size: 12px;
    margin-bottom: 0;
}
.check_box {
    display: flex;
    position: relative;
    pointer-events: none;
    height: fit-content;
}
.check_box input[type="checkbox"] {
    display: none;
}
.check_box label {
    position: relative;
    box-sizing: border-box;
    border: 0px solid #f2f1f2;
    width: 10px;
    height: 10px;
    transition: all 0.1s ease;
    z-index: 2;
    box-shadow: 0px 0px 0px 2px #f2f1f2;
    display: block;
    background: white;
    pointer-events: none;
    margin-bottom: 0;
}
.green input[type="checkbox"]:checked ~ label{
    background: #0cc2aa;
    border: 2px solid white;
}
.purple input[type="checkbox"]:checked ~ label{
    background: #6d0cc2;
    border: 2px solid white;
}
.b-overlay-wrap{
    height: auto;
}
.red input[type="checkbox"]:checked ~ label{
    background: #f45369;
    border: 2px solid white;
}
.yellow input[type="checkbox"]:checked ~ label{
    background: #ffae0c;
    border: 2px solid white;
}

tbody span{
    color: #777e90;
    font-size: 12px;
    font-weight: 500;
}
tr{
    text-align: center !important;
}
.absolute-left{

    z-index: 0;
}
.warn_image{
    width: 20px;
    max-height: 22px;
    margin-left: -3px;
}
.icons svg:not(:last-child){
    margin-right: 10px;
}
.icons svg{
    font-size: 17px;
}
.icons .upload{
    color: #848484;
}
.icons .download{
    color: #0ce9c8;
}
.icons .download.yellow   {
    color: #ffae0c ;
}
.icons .delete{
    color: #f44455;
    font-size: 19px;
}
.padding-box .table-responsive{
    overflow-y: auto;
    max-height: calc(100% - 60px);
}
.b-table-sticky-header, .table-responsive {
    margin-bottom: 0;
}
.download-button{
    cursor: pointer;
    padding:1px 20px;
    font-size: 12px;
    color:white;
    background: #ea8196;
    border-color: #ea8196;
    border-radius: 3px;
    border-style: solid;
    box-shadow: none;
    cursor: pointer;
    margin-left: 20px;
    display:block;
}
a:hover{
    text-decoration: none !important;
}
.download_icon{
    margin-left:25px ;
}
.document_name{
    order: 1;
    margin-left: 30px;
}
.green_text{
    color: #0cc2aa;
}
.red_text{
    color:#f45369
}
@media screen and (max-width: 1537px) {
  .download_icon {
    margin-left: 15px;
  }
}
@media(max-width:1500px){
    .download-button{
        padding:1px 10px;
    }
}
@media screen and (max-width: 1441px) {
  .download_icon {
    margin-left: 5px;
  }
}
</style>

<style>
.customTable .table td:first-child, .customTable .table th:first-child{
	width: 40%;
}
.customTable .table td:nth-child(2), .customTable .table th:nth-child(2){
	width: 15%;
}
.customTable .table td:nth-child(3), .customTable .table th:nth-child(3){
	width: 15%;
}
.customTable .table td:nth-child(4), .customTable .table th:nth-child(4){
	width: 30%;
}
#TabelFisiereFinal td{
    vertical-align: center;
}

#TabelFisiereFinal tr{
    text-align: center !important;
    font-size: 14px !important;

}
#TabelFisiereFinal .relative{
    position: relative;
    display: flex;
    padding-left:16px;
    align-items: center;
}


#TabelFisiereFinal tr{
    background: #ffffff;
    border-color: #dee2e6;
}
#TabelFisiereFinal .yellow-text{
    color: #ffbf00 !important;
}
/*#TabelFisiereFinal tr:nth-child(odd){
    background: #ffffff;
}
#TabelFisiereFinal tr:nth-child(even){
    background: #f9f9f9;
}*/
@media (min-width: 2000px){
    .table-responsive{
        max-height: inherit !important;
    }
}
@media (min-width: 1100px) and (max-width: 1145px){
  .table-responsive{
    margin-bottom: 30px!important;
  }
}
</style>
